import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const uniqueeldproConfig: TSPConfig = {
  key: 'uniqueeldpro',
  name: 'Unique ELD Pro',
  imageName: 'UniqueELDPro',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your Unique ELD Pro profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default uniqueeldproConfig;
